import { useState, useEffect, useCallback } from 'react';

const useVersionCheck = () => {
  const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false);

  useEffect(() => {
    // Función para verificar nueva versión (adaptada de tu código Vite para React/CRA)
    const checkForUpdates = async () => {
      try {
        // Usamos un timestamp para evitar la caché del navegador
        const timestamp = new Date().getTime();

        // Solicitamos el archivo index.html que siempre cambia con cada build
        const response = await fetch(`/?cache-bust=${timestamp}`);
        const htmlContent = await response.text();

        // Extraemos un "fingerprint" del contenido HTML
        // Para React/CRA, buscamos archivos en /static/js/ con hash
        const assetMatch = htmlContent.match(/static\/js\/[^"]+\.js/);

        if (assetMatch) {
          const currentFingerprint = assetMatch[0];
          const savedFingerprint = localStorage.getItem('appFingerprint');

          console.log('🔍 Fingerprint actual:', currentFingerprint);
          console.log('💾 Fingerprint guardado:', savedFingerprint);

          // Si es la primera vez, guardamos el fingerprint
          if (!savedFingerprint) {
            localStorage.setItem('appFingerprint', currentFingerprint);
            console.log('✅ Fingerprint inicial guardado');
          }
          // Si ya tenemos un fingerprint guardado y es diferente, hay una nueva versión
          else if (savedFingerprint !== currentFingerprint) {
            console.log('🚀 ¡Nueva versión detectada!');
            setIsNewVersionAvailable(true);
          } else {
            // Si los fingerprints coinciden, no hay nueva versión
            console.log('✅ Misma versión');
          }
        }
      } catch (error) {
        console.error('❌ Error al verificar actualización:', error);
      }
    };

    // Verificamos al inicio
    checkForUpdates();

    // Y luego cada 3 minutos
    const interval = setInterval(checkForUpdates, 3 * 60 * 1000);

         return () => clearInterval(interval);
   }, []);

  // Función para actualizar la app (adaptada de tu código)
  const refreshApp = useCallback(() => {
    // Actualizar el fingerprint guardado antes de recargar
    const updateFingerprint = async () => {
      try {
        const timestamp = new Date().getTime();
        const response = await fetch(`/?cache-bust=${timestamp}`);
        const htmlContent = await response.text();
        const assetMatch = htmlContent.match(/static\/js\/[^"]+\.js/);

        if (assetMatch) {
          const currentFingerprint = assetMatch[0];
          // Actualizamos el fingerprint guardado
          localStorage.setItem('appFingerprint', currentFingerprint);
          console.log('💾 Fingerprint actualizado antes de recargar');
        }
      } catch (error) {
        console.error('❌ Error al actualizar fingerprint:', error);
      }
      
      // Recargamos la página
      window.location.reload();
    };

    updateFingerprint();
  }, []);

  // Función para testing manual
  const simulateNewVersion = useCallback(() => {
    console.log('🧪 Simulando nueva versión para testing...');
    setIsNewVersionAvailable(true);
  }, []);

  return {
    isNewVersionAvailable,
    refreshApp,
    simulateNewVersion
  };
};

export default useVersionCheck; 